import { ReactNode, useEffect } from "react";
import { FaDollarSign } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import { TbPackages } from "react-icons/tb";
import { Theme, useMediaQuery } from "@mui/system";
import {  BiWallet } from "react-icons/bi";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { isUndefined } from "lodash";
import { useSelector } from "react-redux";
import { RootState } from "@/store/type";
import { HiOutlineDocumentDuplicate } from "react-icons/hi";
import { ROLE } from "@/types";
import { routes } from "@/consts";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { ToastContainer } from "react-toastify";
import TopSide from "./components/top-side";
import LeftSide from "./components/left-side";
import { ListCheckIcon, StoreIcon } from "lucide-react";

function LayoutHeader({
  openSideBar,
  toggleOpenSideBar,
  children,
}: {
  openSideBar: boolean;
  toggleOpenSideBar: () => void;
  children: ReactNode;
}) {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const authUser = useSelector((state: RootState) => state.auth.authUser);
  const userRole = isUndefined(authUser?.role) ? "" : authUser?.role;

  const navMenu = [
    {
      title: t("navigation.Dashboard"),
      path: routes.home,
      show: true,
      icon: <MdDashboard />,
      header: t("navigation.Dashboard"),
    },
    // {
    //   title: t("navigation.procurementManagement"),
    //   path: routes.procurementManagement,
    //   show: userRole === ROLE.BUYER,
    //   icon: <TbPackages />,
    //   header: t("navigation.procurementManagement"),
    // },
    {
      title:
        userRole === ROLE.SELLER
          ? t("navigation.Opportunities")
          : t("navigation.Tenders"),
      show: true,
      path: routes.tenders,
      icon: <AiOutlineFundProjectionScreen />,
      header: t("navigation.OpportunitiesList"),
    },
    {
      title: t("navigation.Orders"),
      show: userRole === ROLE.BUYER,
      path: routes.orders,
      icon: <ListCheckIcon />,
      header: t("navigation.OpportunitiesList"),
    },
    {
      title: t("navigation.SalesManagement"),
      path: routes.orders,
      show: userRole === ROLE.SELLER,
      icon: <TbPackages />,
      header: t("navigation.SalesManagement"),
    },
    {
      title: t("navigation.Wallet"),
      show: true,
      path: routes.payment,
      icon: <BiWallet />,
      header: t("navigation.Wallet"),
    },
    {
      title: t("navigation.Products"),
      show: userRole === ROLE.SELLER,
      path: routes.articles,
      icon: <HiOutlineDocumentDuplicate />,
      header: t("navigation.Products"),
    },
    {
      title: t("navigation.Quotations"),
      show: userRole === ROLE.SELLER,
      path: routes.quatationtenders,
      icon: <FaDollarSign />,
      header: t("navigation.QuotationList"),
    },
  ];
  const marketPlaceList = [
    {
      title: t("marketplace.title"),
      path: routes.marketPlace,
      show: true,
      icon: <MdDashboard />,
      header: t("navigation.Dashboard"),
    },
    // {
    //   title: t("marketplace.products"),
    //   path: routes.products,
    //   show: true,
    //   icon: <AiFillProduct />,
    //   header: t("navigation.Dashboard"),
    // },
    // {
    //   title: t("navigation.MarketPlaceOrders"),
    //   path: routes.marketPlaceOrders,
    //   show: userRole === ROLE.BUYER,
    //   icon: <BiBasket />,
    //   header: t("navigation.Dashboard"),
    // },
    // {
    //   title: t("marketplace.myQuotations"),
    //   path: routes.marketPlaceQuotations,
    //   show: true,
    //   icon: <GoQuote />,
    //   header: t("navigation.Dashboard"),
    // },

    // {
    //   title: t("marketplace.sales"),
    //   path: routes.sales,
    //   show: userRole === ROLE.SELLER,
    //   icon: <IoAnalytics />,
    //   header: t("navigation.Dashboard"),
    // },
    {
      title: t("marketplace.store"),
      path: routes.store,
      show: userRole === ROLE.SELLER,
      icon: <StoreIcon />,
      header: t("navigation.Dashboard"),
    },
  ];

  useEffect(() => {
    if (!isMobile) {
      document.body.style.overflowY = "hidden";
    }
  }, []);

  return (
    <div className="w-full">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="flex overflow-hidden">
        <LeftSide
          marketPlaceList={marketPlaceList}
          navMenu={navMenu}
          toggleOpenSideBar={toggleOpenSideBar}
          openSideBar={openSideBar}
        />
        <TopSide
          marketPlaceList={marketPlaceList}
          openSideBar={openSideBar}
          navMenu={navMenu}
        >
          {children}
        </TopSide>
      </div>
    </div>
  );
}

export default LayoutHeader;
